@if(_documentToken != null && _documentToken != "") {
    <div class="div">
        <ng2-pdfjs-viewer #viewer></ng2-pdfjs-viewer>
    </div>
}
